const config = loadConfig();
export const apiConfig = config.api;
function loadConfig() {
    const env = process.env.NODE_ENV === 'development' ? process.env : window.env;
    const apiConfig = {
        host: env.REACT_APP_API_HOST || '',
        prefix: env.REACT_APP_API_PREFIX || '',
    };
    return {
        api: apiConfig,
    };
}
